import React from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText, DisplayIcon } from 'components';
import {
  DisplayButton,
  ConfirmButton
} from 'components/buttons';

import styles from './DpfSoot.scss';

const DpfSpoot = ({ content }) => {
  const { title, screens, routes } = content;
  const screen = screens[0];
  const screenTitle = screen.title || title;
  const buttonConfig = {
    left: {
      destination: routes.left
    },
    center: {
      destination: routes.center
    },
    right: {
      destination: routes.right
    }
  };

  return [
    <Display key="display">
      <Header>
        <HeaderText value={screenTitle} />
      </Header>
      <Content>
        <div className={styles.iconWrapper}>
          <div className={styles.iconContainer}>
            <span>0</span>
            <DisplayIcon src="icon-xm-bar-half-full" />
            <span>100</span>
          </div>
        </div>
        <Labels values={screen.data} />
      </Content>
      <Footer>
        <DisplayButton src="icon-xm-left-arrow" />
        <ConfirmButton />
        <DisplayButton src="icon-xm-right-arrow" />
      </Footer>
    </Display>,
    <HardwareButtonWrapper key="buttons" config={buttonConfig} />
  ];
};

DpfSpoot.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

export default DpfSpoot;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselService/DpfSoot/DpfSoot.js